export const countryOptions = [
  { label: 'Afghanistan', value: 'AF' },
  { label: 'Åland Islands', value: 'AX' },
  { label: 'Albania', value: 'AL' },
  { label: 'Algeria', value: 'DZ' },
  { label: 'American Samoa', value: 'AS' },
  { label: 'AndorrA', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Anguilla', value: 'AI' },
  { label: 'Antarctica', value: 'AQ' },
  { label: 'Antigua and Barbuda', value: 'AG' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armenia', value: 'AM' },
  { label: 'Aruba', value: 'AW' },
  { label: 'Australia', value: 'AU' },
  { label: 'Austria', value: 'AT' },
  { label: 'Azerbaijan', value: 'AZ' },
  { label: 'Bahamas', value: 'BS' },
  { label: 'Bahrain', value: 'BH' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Belarus', value: 'BY' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Bermuda', value: 'BM' },
  { label: 'Bhutan', value: 'BT' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Bosnia and Herzegovina', value: 'BA' },
  { label: 'Botswana', value: 'BW' },
  { label: 'Bouvet Island', value: 'BV' },
  { label: 'Brazil', value: 'BR' },
  { label: 'British Indian Ocean Territory', value: 'IO' },
  { label: 'Brunei Darussalam', value: 'BN' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Cambodia', value: 'KH' },
  { label: 'Cameroon', value: 'CM' },
  { label: 'Canada', value: 'CA' },
  { label: 'Cape Verde', value: 'CV' },
  { label: 'Cayman Islands', value: 'KY' },
  { label: 'Central African Republic', value: 'CF' },
  { label: 'Chad', value: 'TD' },
  { label: 'Chile', value: 'CL' },
  { label: 'China', value: 'CN' },
  { label: 'Christmas Island', value: 'CX' },
  { label: 'Cocos (Keeling) Islands', value: 'CC' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Comoros', value: 'KM' },
  { label: 'Congo', value: 'CG' },
  { label: 'Congo, The Democratic Republic of the', value: 'CD' },
  { label: 'Cook Islands', value: 'CK' },
  { label: 'Costa Rica', value: 'CR' },
  { label: "Cote D'Ivoire", value: 'CI' },
  { label: 'Croatia', value: 'HR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Cyprus', value: 'CY' },
  { label: 'Czech Republic', value: 'CZ' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Djibouti', value: 'DJ' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Dominican Republic', value: 'DO' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'Egypt', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Equatorial Guinea', value: 'GQ' },
  { label: 'Eritrea', value: 'ER' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Ethiopia', value: 'ET' },
  { label: 'Falkland Islands (Malvinas)', value: 'FK' },
  { label: 'Faroe Islands', value: 'FO' },
  { label: 'Fiji', value: 'FJ' },
  { label: 'Finland', value: 'FI' },
  { label: 'France', value: 'FR' },
  { label: 'French Guiana', value: 'GF' },
  { label: 'French Polynesia', value: 'PF' },
  { label: 'French Southern Territories', value: 'TF' },
  { label: 'Gabon', value: 'GA' },
  { label: 'Gambia', value: 'GM' },
  { label: 'Georgia', value: 'GE' },
  { label: 'Germany', value: 'DE' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Gibraltar', value: 'GI' },
  { label: 'Greece', value: 'GR' },
  { label: 'Greenland', value: 'GL' },
  { label: 'Grenada', value: 'GD' },
  { label: 'Guadeloupe', value: 'GP' },
  { label: 'Guam', value: 'GU' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guernsey', value: 'GG' },
  { label: 'Guinea', value: 'GN' },
  { label: 'Guinea-Bissau', value: 'GW' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Heard Island and Mcdonald Islands', value: 'HM' },
  { label: 'Holy See (Vatican City State)', value: 'VA' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Hong Kong', value: 'HK' },
  { label: 'Hungary', value: 'HU' },
  { label: 'Iceland', value: 'IS' },
  { label: 'India', value: 'IN' },
  { label: 'Indonesia', value: 'ID' },
  { label: 'Iran, Islamic Republic Of', value: 'IR' },
  { label: 'Iraq', value: 'IQ' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Isle of Man', value: 'IM' },
  { label: 'Israel', value: 'IL' },
  { label: 'Italy', value: 'IT' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'Japan', value: 'JP' },
  { label: 'Jersey', value: 'JE' },
  { label: 'Jordan', value: 'JO' },
  { label: 'Kazakhstan', value: 'KZ' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Kiribati', value: 'KI' },
  { label: "Korea, Democratic People'S Republic of", value: 'KP' },
  { label: 'Korea, Republic of', value: 'KR' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Kyrgyzstan', value: 'KG' },
  { label: "Lao People'S Democratic Republic", value: 'LA' },
  { label: 'Latvia', value: 'LV' },
  { label: 'Lebanon', value: 'LB' },
  { label: 'Lesotho', value: 'LS' },
  { label: 'Liberia', value: 'LR' },
  { label: 'Libyan Arab Jamahiriya', value: 'LY' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Lithuania', value: 'LT' },
  { label: 'Luxembourg', value: 'LU' },
  { label: 'Macao', value: 'MO' },
  { label: 'Macedonia, The Former Yugoslav Republic of', value: 'MK' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malawi', value: 'MW' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Maldives', value: 'MV' },
  { label: 'Mali', value: 'ML' },
  { label: 'Malta', value: 'MT' },
  { label: 'Marshall Islands', value: 'MH' },
  { label: 'Martinique', value: 'MQ' },
  { label: 'Mauritania', value: 'MR' },
  { label: 'Mauritius', value: 'MU' },
  { label: 'Mayotte', value: 'YT' },
  { label: 'Mexico', value: 'MX' },
  { label: 'Micronesia, Federated States of', value: 'FM' },
  { label: 'Moldova, Republic of', value: 'MD' },
  { label: 'Monaco', value: 'MC' },
  { label: 'Mongolia', value: 'MN' },
  { label: 'Montserrat', value: 'MS' },
  { label: 'Morocco', value: 'MA' },
  { label: 'Mozambique', value: 'MZ' },
  { label: 'Myanmar', value: 'MM' },
  { label: 'Namibia', value: 'NA' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'Netherlands Antilles', value: 'AN' },
  { label: 'New Caledonia', value: 'NC' },
  { label: 'New Zealand', value: 'NZ' },
  { label: 'Nicaragua', value: 'NI' },
  { label: 'Niger', value: 'NE' },
  { label: 'Nigeria', value: 'NG' },
  { label: 'Niue', value: 'NU' },
  { label: 'Norfolk Island', value: 'NF' },
  { label: 'Northern Mariana Islands', value: 'MP' },
  { label: 'Norway', value: 'NO' },
  { label: 'Oman', value: 'OM' },
  { label: 'Pakistan', value: 'PK' },
  { label: 'Palau', value: 'PW' },
  { label: 'Palestinian Territory, Occupied', value: 'PS' },
  { label: 'Panama', value: 'PA' },
  { label: 'Papua New Guinea', value: 'PG' },
  { label: 'Paraguay', value: 'PY' },
  { label: 'Peru', value: 'PE' },
  { label: 'Philippines', value: 'PH' },
  { label: 'Pitcairn', value: 'PN' },
  { label: 'Poland', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'Qatar', value: 'QA' },
  { label: 'Reunion', value: 'RE' },
  { label: 'Romania', value: 'RO' },
  { label: 'Russian Federation', value: 'RU' },
  { label: 'RWANDA', value: 'RW' },
  { label: 'Saint Helena', value: 'SH' },
  { label: 'Saint Kitts and Nevis', value: 'KN' },
  { label: 'Saint Lucia', value: 'LC' },
  { label: 'Saint Pierre and Miquelon', value: 'PM' },
  { label: 'Saint Vincent and the Grenadines', value: 'VC' },
  { label: 'Samoa', value: 'WS' },
  { label: 'San Marino', value: 'SM' },
  { label: 'Sao Tome and Principe', value: 'ST' },
  { label: 'Saudi Arabia', value: 'SA' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Serbia and Montenegro', value: 'CS' },
  { label: 'Seychelles', value: 'SC' },
  { label: 'Sierra Leone', value: 'SL' },
  { label: 'Singapore', value: 'SG' },
  { label: 'Slovakia', value: 'SK' },
  { label: 'Slovenia', value: 'SI' },
  { label: 'Solomon Islands', value: 'SB' },
  { label: 'Somalia', value: 'SO' },
  { label: 'South Africa', value: 'ZA' },
  { label: 'South Georgia and the South Sandwich Islands', value: 'GS' },
  { label: 'Spain', value: 'ES' },
  { label: 'Sri Lanka', value: 'LK' },
  { label: 'Sudan', value: 'SD' },
  { label: 'Suriname', value: 'SR' },
  { label: 'Svalbard and Jan Mayen', value: 'SJ' },
  { label: 'Swaziland', value: 'SZ' },
  { label: 'Sweden', value: 'SE' },
  { label: 'Switzerland', value: 'CH' },
  { label: 'Syrian Arab Republic', value: 'SY' },
  { label: 'Taiwan, Province of China', value: 'TW' },
  { label: 'Tajikistan', value: 'TJ' },
  { label: 'Tanzania, United Republic of', value: 'TZ' },
  { label: 'Thailand', value: 'TH' },
  { label: 'Timor-Leste', value: 'TL' },
  { label: 'Togo', value: 'TG' },
  { label: 'Tokelau', value: 'TK' },
  { label: 'Tonga', value: 'TO' },
  { label: 'Trinidad and Tobago', value: 'TT' },
  { label: 'Tunisia', value: 'TN' },
  { label: 'Turkey', value: 'TR' },
  { label: 'Turkmenistan', value: 'TM' },
  { label: 'Turks and Caicos Islands', value: 'TC' },
  { label: 'Tuvalu', value: 'TV' },
  { label: 'Uganda', value: 'UG' },
  { label: 'Ukraine', value: 'UA' },
  { label: 'United Arab Emirates', value: 'AE' },
  { label: 'United Kingdom', value: 'GB' },
  { label: 'United States', value: 'US' },
  { label: 'United States Minor Outlying Islands', value: 'UM' },
  { label: 'Uruguay', value: 'UY' },
  { label: 'Uzbekistan', value: 'UZ' },
  { label: 'Vanuatu', value: 'VU' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'Viet Nam', value: 'VN' },
  { label: 'Virgin Islands, British', value: 'VG' },
  { label: 'Virgin Islands, U.S.', value: 'VI' },
  { label: 'Wallis and Futuna', value: 'WF' },
  { label: 'Western Sahara', value: 'EH' },
  { label: 'Yemen', value: 'YE' },
  { label: 'Zambia', value: 'ZM' },
  { label: 'Zimbabwe', value: 'ZW' },
];

export const NationalList = [
  { label: 'Afghan', value: 'Afghan' },
  { label: 'Albanian', value: 'Albanian' },
  { label: 'Algerian', value: 'Algerian' },
  { label: 'American', value: 'American' },
  { label: 'Andorran', value: 'Andorran' },
  { label: 'Angolan', value: 'Angolan' },
  { label: 'Anguillan', value: 'Anguillan' },
  { label: 'Argentine', value: 'Argentine' },
  { label: 'Armenian', value: 'Armenian' },
  { label: 'Australian', value: 'Australian' },
  { label: 'Austrian', value: 'Austrian' },
  { label: 'Azerbaijani', value: 'Azerbaijani' },
  { label: 'Bahamian', value: 'Bahamian' },
  { label: 'Bahraini', value: 'Bahraini' },
  { label: 'Bangladeshi', value: 'Bangladeshi' },
  { label: 'Barbadian', value: 'Barbadian' },
  { label: 'Belarusian', value: 'Belarusian' },
  { label: 'Belgian', value: 'Belgian' },
  { label: 'Belizean', value: 'Belizean' },
  { label: 'Beninese', value: 'Beninese' },
  { label: 'Bermudian', value: 'Bermudian' },
  { label: 'Bhutanese', value: 'Bhutanese' },
  { label: 'Bolivian', value: 'Bolivian' },
  { label: 'Botswanan', value: 'Botswanan' },
  { label: 'Brazilian', value: 'Brazilian' },
  { label: 'British', value: 'British' },
  { label: 'British Virgin Islander', value: 'British Virgin Islander' },
  { label: 'Bruneian', value: 'Bruneian' },
  { label: 'Bulgarian', value: 'Bulgarian' },
  { label: 'Burkinan', value: 'Burkinan' },
  { label: 'Burmese', value: 'Burmese' },
  { label: 'Burundian', value: 'Burundian' },
  { label: 'Cambodian', value: 'Cambodian' },
  { label: 'Cameroonian', value: 'Cameroonian' },
  { label: 'Canadian', value: 'Canadian' },
  { label: 'Cape Verdean', value: 'Cape Verdean' },
  { label: 'Cayman Islander', value: 'Cayman Islander' },
  { label: 'Central African', value: 'Central African' },
  { label: 'Chadian', value: 'Chadian' },
  { label: 'Chilean', value: 'Chilean' },
  { label: 'Chinese', value: 'Chinese' },
  { label: 'Citizen of Antigua and Barbuda', value: 'Citizen of Antigua and Barbuda' },
  { label: 'Citizen of Bosnia and Herzegovina', value: 'Citizen of Bosnia and Herzegovina' },
  { label: 'Citizen of Guinea-Bissau', value: 'Citizen of Guinea-Bissau' },
  { label: 'Citizen of Kiribati', value: 'Citizen of Kiribati' },
  { label: 'Citizen of Seychelles', value: 'Citizen of Seychelles' },
  { label: 'Citizen of the Dominican Republic', value: 'Citizen of the Dominican Republic' },
  { label: 'Citizen of Vanuatu', value: 'Citizen of Vanuatu' },
  { label: 'Colombian', value: 'Colombian' },
  { label: 'Comoran', value: 'Comoran' },
  { label: 'Congolese (Congo)', value: 'Congolese (Congo)' },
  { label: 'Congolese (DRC)', value: 'Congolese (DRC)' },
  { label: 'Cook Islander', value: 'Cook Islander' },
  { label: 'Costa Rican', value: 'Costa Rican' },
  { label: 'Croatian', value: 'Croatian' },
  { label: 'Cuban', value: 'Cuban' },
  { label: 'Cymraes', value: 'Cymraes' },
  { label: 'Cymro', value: 'Cymro' },
  { label: 'Cypriot', value: 'Cypriot' },
  { label: 'Czech', value: 'Czech' },
  { label: 'Danish', value: 'Danish' },
  { label: 'Djiboutian', value: 'Djiboutian' },
  { label: 'Dominican', value: 'Dominican' },
  { label: 'Dutch', value: 'Dutch' },
  { label: 'East Timorese', value: 'East Timorese' },
  { label: 'Ecuadorean', value: 'Ecuadorean' },
  { label: 'Egyptian', value: 'Egyptian' },
  { label: 'Emirati', value: 'Emirati' },
  { label: 'English', value: 'English' },
  { label: 'Equatorial Guinean', value: 'Equatorial Guinean' },
  { label: 'Eritrean', value: 'Eritrean' },
  { label: 'Estonian', value: 'Estonian' },
  { label: 'Ethiopian', value: 'Ethiopian' },
  { label: 'Faroese', value: 'Faroese' },
  { label: 'Fijian', value: 'Fijian' },
  { label: 'Filipino', value: 'Filipino' },
  { label: 'Finnish', value: 'Finnish' },
  { label: 'French', value: 'French' },
  { label: 'Gabonese', value: 'Gabonese' },
  { label: 'Gambian', value: 'Gambian' },
  { label: 'Georgian', value: 'Georgian' },
  { label: 'German', value: 'German' },
  { label: 'Ghanaian', value: 'Ghanaian' },
  { label: 'Gibraltarian', value: 'Gibraltarian' },
  { label: 'Greek', value: 'Greek' },
  { label: 'Greenlandic', value: 'Greenlandic' },
  { label: 'Grenadian', value: 'Grenadian' },
  { label: 'Guamanian', value: 'Guamanian' },
  { label: 'Guatemalan', value: 'Guatemalan' },
  { label: 'Guinean', value: 'Guinean' },
  { label: 'Guyanese', value: 'Guyanese' },
  { label: 'Haitian', value: 'Haitian' },
  { label: 'Honduran', value: 'Honduran' },
  { label: 'Hong Konger', value: 'Hong Konger' },
  { label: 'Hungarian', value: 'Hungarian' },
  { label: 'Icelandic', value: 'Icelandic' },
  { label: 'Indian', value: 'Indian' },
  { label: 'Indonesian', value: 'Indonesian' },
  { label: 'Iranian', value: 'Iranian' },
  { label: 'Iraqi', value: 'Iraqi' },
  { label: 'Irish', value: 'Irish' },
  { label: 'Israeli', value: 'Israeli' },
  { label: 'Italian', value: 'Italian' },
  { label: 'Ivorian', value: 'Ivorian' },
  { label: 'Jamaican', value: 'Jamaican' },
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Jordanian', value: 'Jordanian' },
  { label: 'Kazakh', value: 'Kazakh' },
  { label: 'Kenyan', value: 'Kenyan' },
  { label: 'Kittitian', value: 'Kittitian' },
  { label: 'Kosovan', value: 'Kosovan' },
  { label: 'Kuwaiti', value: 'Kuwaiti' },
  { label: 'Kyrgyz', value: 'Kyrgyz' },
  { label: 'Lao', value: 'Lao' },
  { label: 'Latvian', value: 'Latvian' },
  { label: 'Lebanese', value: 'Lebanese' },
  { label: 'Liberian', value: 'Liberian' },
  { label: 'Libyan', value: 'Libyan' },
  { label: 'Liechtenstein citizen', value: 'Liechtenstein citizen' },
  { label: 'Lithuanian', value: 'Lithuanian' },
  { label: 'Luxembourger', value: 'Luxembourger' },
  { label: 'Macanese', value: 'Macanese' },
  { label: 'Macedonian', value: 'Macedonian' },
  { label: 'Malagasy', value: 'Malagasy' },
  { label: 'Malawian', value: 'Malawian' },
  { label: 'Malaysian', value: 'Malaysian' },
  { label: 'Maldivian', value: 'Maldivian' },
  { label: 'Malian', value: 'Malian' },
  { label: 'Maltese', value: 'Maltese' },
  { label: 'Marshallese', value: 'Marshallese' },
  { label: 'Martiniquais', value: 'Martiniquais' },
  { label: 'Mauritanian', value: 'Mauritanian' },
  { label: 'Mauritian', value: 'Mauritian' },
  { label: 'Mexican', value: 'Mexican' },
  { label: 'Micronesian', value: 'Micronesian' },
  { label: 'Moldovan', value: 'Moldovan' },
  { label: 'Monegasque', value: 'Monegasque' },
  { label: 'Mongolian', value: 'Mongolian' },
  { label: 'Montenegrin', value: 'Montenegrin' },
  { label: 'Montserratian', value: 'Montserratian' },
  { label: 'Moroccan', value: 'Moroccan' },
  { label: 'Mosotho', value: 'Mosotho' },
  { label: 'Mozambican', value: 'Mozambican' },
  { label: 'Namibian', value: 'Namibian' },
  { label: 'Nauruan', value: 'Nauruan' },
  { label: 'Nepalese', value: 'Nepalese' },
  { label: 'New Zealander', value: 'New Zealander' },
  { label: 'Nicaraguan', value: 'Nicaraguan' },
  { label: 'Nigerian', value: 'Nigerian' },
  { label: 'Nigerien', value: 'Nigerien' },
  { label: 'Niuean', value: 'Niuean' },
  { label: 'North Korean', value: 'North Korean' },
  { label: 'Northern Irish', value: 'Northern Irish' },
  { label: 'Norwegian', value: 'Norwegian' },
  { label: 'Omani', value: 'Omani' },
  { label: 'Pakistani', value: 'Pakistani' },
  { label: 'Palauan', value: 'Palauan' },
  { label: 'Palestinian', value: 'Palestinian' },
  { label: 'Panamanian', value: 'Panamanian' },
  { label: 'Papua New Guinean', value: 'Papua New Guinean' },
  { label: 'Paraguayan', value: 'Paraguayan' },
  { label: 'Peruvian', value: 'Peruvian' },
  { label: 'Pitcairn Islander', value: 'Pitcairn Islander' },
  { label: 'Polish', value: 'Polish' },
  { label: 'Portuguese', value: 'Portuguese' },
  { label: 'Prydeinig', value: 'Prydeinig' },
  { label: 'Puerto Rican', value: 'Puerto Rican' },
  { label: 'Qatari', value: 'Qatari' },
  { label: 'Romanian', value: 'Romanian' },
  { label: 'Russian', value: 'Russian' },
  { label: 'Rwandan', value: 'Rwandan' },
  { label: 'Salvadorean', value: 'Salvadorean' },
  { label: 'Sammarinese', value: 'Sammarinese' },
  { label: 'Samoan', value: 'Samoan' },
  { label: 'Sao Tomean', value: 'Sao Tomean' },
  { label: 'Saudi Arabian', value: 'Saudi Arabian' },
  { label: 'Scottish', value: 'Scottish' },
  { label: 'Senegalese', value: 'Senegalese' },
  { label: 'Serbian', value: 'Serbian' },
  { label: 'Sierra Leonean', value: 'Sierra Leonean' },
  { label: 'Singaporean', value: 'Singaporean' },
  { label: 'Slovak', value: 'Slovak' },
  { label: 'Slovenian', value: 'Slovenian' },
  { label: 'Solomon Islander', value: 'Solomon Islander' },
  { label: 'Somali', value: 'Somali' },
  { label: 'South African', value: 'South African' },
  { label: 'South Korean', value: 'South Korean' },
  { label: 'South Sudanese', value: 'South Sudanese' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'Sri Lankan', value: 'Sri Lankan' },
  { label: 'St Helenian', value: 'St Helenian' },
  { label: 'St Lucian', value: 'St Lucian' },
  { label: 'Stateless', value: 'Stateless' },
  { label: 'Sudanese', value: 'Sudanese' },
  { label: 'Surinamese', value: 'Surinamese' },
  { label: 'Swazi', value: 'Swazi' },
  { label: 'Swedish', value: 'Swedish' },
  { label: 'Swiss', value: 'Swiss' },
  { label: 'Syrian', value: 'Syrian' },
  { label: 'Taiwanese', value: 'Taiwanese' },
  { label: 'Tajik', value: 'Tajik' },
  { label: 'Tanzanian', value: 'Tanzanian' },
  { label: 'Thai', value: 'Thai' },
  { label: 'Togolese', value: 'Togolese' },
  { label: 'Tongan', value: 'Tongan' },
  { label: 'Trinidadian', value: 'Trinidadian' },
  { label: 'Tristanian', value: 'Tristanian' },
  { label: 'Tunisian', value: 'Tunisian' },
  { label: 'Turkish', value: 'Turkish' },
  { label: 'Turkmen', value: 'Turkmen' },
  { label: 'Turks and Caicos Islander', value: 'Turks and Caicos Islander' },
  { label: 'Tuvaluan', value: 'Tuvaluan' },
  { label: 'Ugandan', value: 'Ugandan' },
  { label: 'Ukrainian', value: 'Ukrainian' },
  { label: 'Uruguayan', value: 'Uruguayan' },
  { label: 'Uzbek', value: 'Uzbek' },
  { label: 'Vatican citizen', value: 'Vatican citizen' },
  { label: 'Venezuelan', value: 'Venezuelan' },
  { label: 'Vietnamese', value: 'Vietnamese' },
  { label: 'Vincentian', value: 'Vincentian' },
  { label: 'Wallisian', value: 'Wallisian' },
  { label: 'Welsh', value: 'Welsh' },
  { label: 'Yemeni', value: 'Yemeni' },
  { label: 'Zambian', value: 'Zambian' },
  { label: 'Zimbabwean', value: 'Zimbabwean' },
];